import { render } from "./Ballots.vue?vue&type=template&id=183bc361&scoped=true"
import script from "./Ballots.vue?vue&type=script&lang=ts"
export * from "./Ballots.vue?vue&type=script&lang=ts"

import "./Ballots.vue?vue&type=style&index=0&id=183bc361&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-183bc361"

export default script